import { Pipe, PipeTransform } from '@angular/core';

export type TypeGuard<A, B extends A> = (a: A) => a is B;

/**
 * Source:
 * https://stackblitz.com/edit/angular-guard-type-pipe
 */

@Pipe({ name: 'typeGuard' })
export class TypeGuardPipe implements PipeTransform {
    public transform<A, B extends A>(value: A, typeGuard: TypeGuard<A, B>): B | undefined {
        return typeGuard(value) ? value : undefined;
    }
}
